import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import commonService from 'utils/commonService';
import { IProps } from './types';

const PaymentInfo: React.FC<IProps> = (props) => {
  const [idProtected, setIdProtected] = useState<boolean>(true);
  const resources = useSelector((state: RootReducersState) => state.resources);

  /**
   * @description 處理付款人ID資料顯示或隱藏切換
   */
  const handleIdViewToggle = () => {
    setIdProtected((prevState) => !prevState);
  };

  return (
    <div className="payment-info">
      <div className="payment-info__title">{commonService.getNameByLng(resources, 'TID_Payment_information')}</div>
      <div className="payment-info__content">
        <div className="element__list">
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Payment_method')}</div>
              <div className="element__list-group-content">{props.PAY_BY ? props.PAY_BY : '-'}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Payer_name')}</div>
              <div className="element__list-group-content">{props.PAYER_NAME ? props.PAYER_NAME : '-'}</div>
            </div>
          </div>
          {/* <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">信用卡卡號</div>
              <div className="element__list-group-content">{props.CARD_NO ? props.CARD_NO : '-'}</div>
            </div>
          </div> */}
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Bank_of_current_account')}</div>
              <div className="element__list-group-content">{props.BANK ? props.BANK : '-'}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Transaction_time')}</div>
              <div className="element__list-group-content">{props.TRANSACTION ? props.TRANSACTION : '-'}</div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Payer_ID')}</div>
              <div className="element__list-group-content">
                {!idProtected
                  ? props.PAYER_ID ? props.PAYER_ID : '-'
                  : props.PAYER_ID ? commonService.hiddenStringLastCharacter(props.PAYER_ID, 5) : '-'}
                {props.PAYER_ID && (
                  <button type="button" className="element__view-btn" onClick={handleIdViewToggle}>
                    {!idProtected ? <i className="fas fa-eye" /> : <i className="fas fa-eye-slash" />}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className={'element__list-col' + (resources.lng === 'en' ? ' element__list-col--full' : '')}>
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Current_account_number_last_five_digits')}</div>
              <div className="element__list-group-content">{props.BANK_ACCOUNT ? props.BANK_ACCOUNT : '-'}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Transaction_amount')}</div>
              <div className="element__list-group-content">{props.AMOUNT ? commonService.thousandFormat(`${props.AMOUNT}`) : '-'}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
